import { useAuthenticationStore } from "@stores/authentication";
import axios from "@utilities/axios";

export const reportError = (errorMessage: any, eventSubType?: string): void => {
  const authenticationState = useAuthenticationStore.getState();

  const formData = new FormData();
  formData.append("action", "save");
  formData.append("event_type", "BNESIM_SHOP_EVENT");

  if (eventSubType) {
    formData.append("event_subtype", eventSubType);
  }
  formData.append("error_message", errorMessage);
  formData.append("page", window.location.href);
  formData.append("stack_trace", new Error().stack ?? "");
  formData.append("user_agent", navigator.userAgent);

  const request = "/error_binding/";

  axios
    .post(request, formData)
    .then(() => {
      console.log("Error reported successfully");
    })
    .catch(error => {
      console.error("Error reporting failed:", error.message);
    });
};
